const KEYS = {
  contracts: 'callie_contracts',
  settings: 'callie_settings',
  edls: 'callie_edls',
  pendingSync: 'callie_pending_sync',
  theme: 'callie_theme',
}

// Normalize ISO dates "2026-08-01T00:00:00.000Z" → "2026-08-01"
const nd = (d) => d ? String(d).split('T')[0] : d
// Uniformise 'payé' (accent, écrit par le site public) → 'paid'
const ns = (s) => (s === 'payé' || s === 'paye') ? 'paid' : s
const normalizeContract = (c) => ({ ...c, startDate: nd(c.startDate), endDate: nd(c.endDate), status: ns(c.status) })

export const storage = {
  getContracts: () => {
    const arr = JSON.parse(localStorage.getItem(KEYS.contracts) || '[]')
    return arr.map(normalizeContract)
  },
  saveContracts: (contracts) => localStorage.setItem(KEYS.contracts, JSON.stringify(contracts.map(normalizeContract))),
  addContract: (contract) => {
    const contracts = storage.getContracts()
    const existing = contracts.findIndex(c => c.id === contract.id)
    const norm = normalizeContract(contract)
    if (existing >= 0) contracts[existing] = norm
    else contracts.push(norm)
    storage.saveContracts(contracts)
    return norm
  },

  getSettings: () => {
    const saved = localStorage.getItem(KEYS.settings)
    if (!saved) return null
    return JSON.parse(saved)
  },
  saveSettings: (settings) => localStorage.setItem(KEYS.settings, JSON.stringify(settings)),

  getEdls: () => JSON.parse(localStorage.getItem(KEYS.edls) || '[]'),
  saveEdl: (edl) => {
    const edls = storage.getEdls()
    const existing = edls.findIndex(e => e.contractId === edl.contractId && e.type === edl.type)
    if (existing >= 0) edls[existing] = edl
    else edls.push(edl)
    localStorage.setItem(KEYS.edls, JSON.stringify(edls))
  },
  getEdlForContract: (contractId, type) => {
    const edls = storage.getEdls()
    return edls.find(e => e.contractId === contractId && e.type === type) || null
  },

  getPending: () => JSON.parse(localStorage.getItem(KEYS.pendingSync) || '[]'),
  addPending: (item) => {
    const pending = storage.getPending()
    pending.push(item)
    localStorage.setItem(KEYS.pendingSync, JSON.stringify(pending))
  },
  clearPending: () => localStorage.setItem(KEYS.pendingSync, '[]'),
  removePendingById: (id) => {
    const pending = storage.getPending().filter(p => p.id !== id)
    localStorage.setItem(KEYS.pendingSync, JSON.stringify(pending))
  },

  getTheme: () => localStorage.getItem(KEYS.theme) || 'dark',
  saveTheme: (theme) => localStorage.setItem(KEYS.theme, theme),
}
